// Auto-generated by the generator
// Don't manually edit this file

// @flow

import type {Action} from '../../types'
import type {MapState} from '../types'

import {setReadyReducer} from './setReady'
import {setApiIndexReducer} from './setApiIndex'
import {setServiceProvidersReducer} from './setServiceProviders'
import {setGoogleMapReducer} from './setGoogleMap'
import {setLocationReducer} from './setLocation'
import {setCitiesReducer} from './setCities'
import {setDistrictsReducer} from './setDistricts'
import {setSelectedCityReducer} from './setSelectedCity'
import {initialState} from './initialState'

export const mapReducer = (state: MapState = initialState, action: Action<any>): MapState => {
  switch (action.type) {
    case 'map/SET_READY':
      return setReadyReducer(state, action)
    case 'map/SET_API_INDEX':
      return setApiIndexReducer(state, action)
    case 'map/SET_SERVICE_PROVIDERS':
      return setServiceProvidersReducer(state, action)
    case 'map/SET_GOOGLE_MAP':
      return setGoogleMapReducer(state, action)
    case 'map/SET_LOCATION':
      return setLocationReducer(state, action)
    case 'map/SET_CITIES':
      return setCitiesReducer(state, action)
    case 'map/SET_DISTRICTS':
      return setDistrictsReducer(state, action)
    case 'map/SET_SELECTED_CITY':
      return setSelectedCityReducer(state, action)
    default:
      return state
  }
}
